exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch-store-button-container{position:sticky;bottom:0;padding:16px;background-color:#fff;border-top:1px solid #e0e0e0;z-index:10}.switch-store-button-container button{width:100%;min-height:48px}", ""]);

// exports
